import { Injectable } from '@angular/core';
import { ISupplier, IIdName } from '../_entities';
import { HttpService } from "../core/http/http.service";
import { DataAccessServiceBase } from "./dataaccess.base.service";
import { ModelStateValidationService } from "./model-state-validation.service";

@Injectable()
export class SupplierService extends DataAccessServiceBase<ISupplier> {

  
    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
        super(httpService, validationService);
    }

    getControllerUrl(): string {
        return "api/supplier";
    }

    get templates(): Promise<IIdName[] | any> {
	    return this.httpService.get<IIdName[] | any>(`${this.getControllerUrl()}/templates`);
    }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/supplier.service.ts